import DestinationTripsTemplate from "./DestinationTripsTemplate";
import { Mountain } from "lucide-react";

const UniversalOrlando = () => {
  return (
    <DestinationTripsTemplate
      destinationId="universal_orlando"
      destinationName="Universal Orlando"
      destinationIcon={Mountain}
      destinationDescription="Create thrilling Universal Orlando experiences for your clients"
      destinationFeatures="Universal Studios • Islands of Adventure • Volcano Bay • Epic Universe • CityWalk • Premier Resorts"
    />
  );
};

export default UniversalOrlando;
